// One gutter for every page that lays its own content out. It tracks the
// window (the old `calc(10px+5vw)`), capped at 80px and floored at 16px so a
// phone keeps its content instead of spending 40% of the screen on padding.
export const PAGE_GUTTER_X = "px-[clamp(1rem,5vw,5rem)]";
// How far below the card header a page's title row starts.
export const PAGE_PADDING_TOP = "pt-16";
export const PAGE_GUTTER = "px-[clamp(1rem,5vw,5rem)] pt-16 pb-6";
// Marks a page-level highlight surface; app/global.css keeps it at the page
// card's depth in dark mode so study pages match the dashboard.
export const PAGE_HIGHLIGHT_SURFACE_CLASS = "page-surface-highlight";
